import React, { useEffect, useRef } from 'react';

import styles from 'sections/welcomeAnim/costumeVariations/mediaCarousel/mediaCarousel.module.css';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Inline from 'yet-another-react-lightbox/plugins/inline';
import Video from 'yet-another-react-lightbox/plugins/video';
import { ArrowRightInCircle } from 'components/vectors/welcomAnim/ArrowRightInCircle';
import { ArrowLeftInCircle } from 'components/vectors/welcomAnim/ArrowLeftInCircle';
import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';

export const MediaCarousel = ({ items }: { items: CustomSlide[] }) => {
    const [open, setOpen] = React.useState(false);
    const [index, setIndex] = React.useState(0);
    const scrollPositionRef = useRef<number>(0);
    const toggleOpen = (state: boolean) => () => {
        if (state) {
            scrollPositionRef.current = window.scrollY || window.pageYOffset;
        }
        setOpen(state);
    };

    const updateIndex = ({ index: current }: { index: number }) =>
        setIndex(current);

    useEffect(() => {
        if (!open) {
            requestAnimationFrame(() => {
                window.scrollTo(0, scrollPositionRef.current);
            });
        }
    }, [open]);

    return (
        <div className={styles.carousel}>
            <Lightbox
                index={index}
                slides={items}
                plugins={[Inline, Video]}
                on={{
                    view: updateIndex,
                    click: toggleOpen(true),
                }}
                carousel={{
                    padding: 0,
                    spacing: 0,
                    imageFit: 'cover',
                }}
                inline={{
                    style: {
                        width: '100%',
                        maxWidth: '900px',
                        aspectRatio: '3 / 2',
                        margin: '0 auto',
                        backgroundColor: '#140101',
                    },
                }}
                render={{
                    iconNext: () => <ArrowRightInCircle />,
                    iconPrev: () => <ArrowLeftInCircle />,
                }}
            />

            <Lightbox
                open={open}
                close={toggleOpen(false)}
                index={index}
                plugins={[Video]}
                slides={items}
                on={{ view: updateIndex }}
                animation={{ fade: 0 }}
                controller={{
                    closeOnPullDown: true,
                    closeOnBackdropClick: true,
                }}
                inline={{
                    style: {
                        backgroundColor: '#140101',
                    },
                }}
            />
        </div>
    );
};
